module.exports = __webpack_public_path__ + "img/pp-38.2c61871b.jpg";